import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-accent-400 font-label text-xs tracking-[0.2em] uppercase mb-3">
            探索分类
          </p>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            丰富的韩漫分类
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto">
            每一种类型都经过精心筛选，找到属于你的漫画世界
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-2xl bg-background-50 p-6 md:p-8 transition-all duration-300 hover:scale-[1.02] cursor-pointer"
            >
              <div className="absolute top-0 right-0 w-32 h-32 bg-accent-500/5 rounded-bl-[80px] transition-all group-hover:bg-accent-500/10"></div>
              <div className="relative z-10">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-5">
                  <i className={`${cat.icon} text-xl md:text-2xl`}></i>
                </div>
                <h3 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-2">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-500 mb-4">{cat.description}</p>
                <div className="flex items-center gap-2">
                  <span className="text-2xl font-bold font-label text-primary-500">{cat.count.toLocaleString()}</span>
                  <span className="text-sm text-foreground-500">部作品</span>
                  <i className="ri-arrow-right-line text-foreground-400 ml-auto group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}